import {createSlice} from '@reduxjs/toolkit'
import {CentralModel} from '../../models'

export const EmptyCentralState: CentralModel = {
  showPanel: false,
  tabs: [
      {
        id: 0, 
        title:'Inicio',
        showPanel:false,
        idToEdit: '',
        idToDelete:'',
        loadingTable:false,
        content: {
          headerPanel: '',
          detailPanel: '',
        },
        submenu:'start',
        closable:false,
        reset:false,
        aditionalInformation:null
      }
  ],
  menu: [],
    currentTab:0,
}

export const centralSlice = createSlice({
  name: 'central',
  initialState: EmptyCentralState,
  reducers: {
    addTabAction: (state, action) => {
      return {...state, tabs:[...state.tabs, action.payload]}
    },
    deleteTabAction: (state, action) => {
      return {...state, tabs: action.payload}
    },
    changeTabAction: (state, action) => {
      return {...state, currentTab: action.payload}
    },
    setCurrentTabItemAction: (state, action) => {
      return {
        ...state,
        tabs: state.tabs.map((tab, idx) =>
          idx === state.currentTab ? {...tab, ...action.payload} : tab
        ),
      }
    },
    setMenuFromApi: (state, action) => {
      return {...state, menu: action.payload}
    },
    resetCentral: () => {
      return EmptyCentralState
    },
  },
})

export const {
  addTabAction,
  deleteTabAction,
  changeTabAction,
  setCurrentTabItemAction,
  resetCentral,
  setMenuFromApi,
} = centralSlice.actions

export default centralSlice.reducer
